import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'project-directories.versions.delete-version.title',
		defaultMessage: 'Delete {name}',
		description: '',
	},
});
export default messages;
